// Path: ./src/app/components/DealProductCard/index_v2.tsx
import CancelIcon from "@mui/icons-material/Cancel";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import IconButton from "@mui/material/IconButton";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { PermissionComponentWrapper } from "../PermissionComponentWrapper";
import {
  Image,
  TitleWrapper,
  Title,
  SubTitle,
  PriceWrapper,
  Sale,
  Was,
  CancelButton,
  AddButton,
  Card,
  Container,
} from "./styled";
import { GfPromotionDto } from "@swagger/typescript-fetch-goflyer";
interface Props {
  promotion: GfPromotionDto;
  showCancelButton?: boolean;
  /**
   * Opens a confirmation modal to delete a Deal.
   *
   */
  cancelButtonClick?: () => void;

  /**
   * Handles the click event of the add button.
   * Edits or adds a deal, depending on the context.
   */
  addButtonClick?: () => void;
  showAddButton?: boolean;
  setAddIcon?: "edit" | "add";
  requiredPermissionDelete?: string[];
  requiredPermissionGroupDelete?: string[];
  requiredPermissionAdd: string[];
  requiredPermissionGroupAdd: string[];
}
/**
 * @param param0
 * @returns
 */
export const DealProductCard_v2 = ({
  promotion,
  showAddButton,
  showCancelButton,
  addButtonClick,
  cancelButtonClick,
  setAddIcon = "add", // by default it's add
  requiredPermissionAdd,
  requiredPermissionDelete,
  requiredPermissionGroupAdd,
  requiredPermissionGroupDelete,
}: Props) => {
  return (
    <Container data-testid="dealproductcard_v2-test-id">
      <Card>
        <Image src={promotion.placement?.product?.gfImages[0]?.src} />
        <TitleWrapper>
          <Title data-testid={"deal-first-language"}>
            {promotion.placement.product.name}
          </Title>
          <SubTitle data-testid={"deal-second-language"}>
            {promotion.placement.product.nameChinese}
          </SubTitle>
        </TitleWrapper>
        <PriceWrapper>
          <Sale>Sale:${promotion.price}</Sale>
          {promotion.placement?.price && (
            <Was>was:${promotion.placement?.price}</Was>
          )}
        </PriceWrapper>
      </Card>
      {showCancelButton && (
        <PermissionComponentWrapper
          requiredPermission={requiredPermissionDelete}
          requiredPermissionGroup={requiredPermissionGroupDelete}
        >
          <CancelButton
            data-testid="deal-delete-button"
            onClick={cancelButtonClick}
          >
            <IconButton sx={{ color: "red" }}>
              <CancelIcon style={{ fontSize: 30 }} />
            </IconButton>
          </CancelButton>
        </PermissionComponentWrapper>
      )}
      {showAddButton && (
        <PermissionComponentWrapper
          requiredPermission={requiredPermissionAdd}
          requiredPermissionGroup={requiredPermissionGroupAdd}
        >
          <AddButton data-testid="deal-edit-button">
            <IconButton sx={{ color: "#ff813a" }} onClick={addButtonClick}>
              {setAddIcon === "add" && (
                <AddCircleIcon style={{ fontSize: 35 }} />
              )}
              {setAddIcon === "edit" && (
                <DriveFileRenameOutlineIcon style={{ fontSize: 35 }} />
              )}
            </IconButton>
          </AddButton>{" "}
        </PermissionComponentWrapper>
      )}
    </Container>
  );
};
